




























import Vue, { PropType } from 'vue'
import IListTile from '@/types/components/IListTile.interface'
import FormSubmission from '@/types/FormSubmission.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import Button from '@/types/components/Button.interface'
export default Vue.extend({
    props: {
        groupId: {
            type: Number,
            required: false,
            default: null
        },
        //  Total number of submissions
        submissionCount: {
            type: Number,
            required: false,
            default: 0
        },
        //  Our form submissions
        submissions: {
            type: Array as PropType<FormSubmission[]>,
            required: true
        }
    },
    data() {
        return {
            submissionIcon: {
                type: IListIconType.icon,
                content: 'mdi-account',
                color: 'primary'
            } as IListIcon,
            submissionsListPlaceholder: {
                content: 'No Submissions Found',
                img: 'noMessages'
            }
        }
    },
    computed: {
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        createFormGroup(): void {
            //  Operators cannot create form groups
            if (this.operator) return

            // Instatiate container for person IDs
            const personIds = []

            // For each form submission, push valid person IDs
            this.submissions.forEach((sub: FormSubmission) => {
                //  If the submission has a person, push only the person id to the array as that's all we need for the group and group memberships table
                if (sub.person) personIds.push(sub.person.id)
            })

            // Instatiate container that has no duplicate person ids, since the form submissions can have
            // multiple submissions from the same person we must filter out dupes otherwise this method will not work
            // as all ids in a group must be unique
            // The set data type does not permit duplicates so we convert array to a set to remove duplicates and then
            // convert it back to an array, based on research this is 8x faster than filter method
            const filterdPersonIds = [...new Set(personIds)];

            //  Tell the parent to create a form group with these persons
            this.$emit('createFormGroup', filterdPersonIds)
        },
        goToGroup(): void {
            this.$router.push(`/groups/${this.groupId}`)
        },
        navigateToContact(submission: FormSubmission): void {
            //  Grab the id of the person belonging to the submission
            const personId = submission.person.id

            //  Navigate to them
            this.$router.push({ path: `/contacts?id=${personId}` })
        },
        navigateToChannel(submission: FormSubmission): void {
            //  Grab the channel id of the person belonging to the submission
            const channelId = submission.person.primary_channel_id

            //  Navigate to them
            this.$router.push(`/inbox?channel=${channelId}`)
        },
        submissionActions(submission: FormSubmission): IListAction {
            //  Create our button menu
            const menu: Button[] = [
                {
                    icon: 'mdi-clipboard-account-outline',
                    text: 'View Submission',
                    color: 'primary',
                    callback: () => this.submissionView(submission)
                },
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete',
                    color: 'primary',
                    callback: () => this.submissionDelete(submission)
                },
                {
                    icon: 'mdi-chevron-right',
                    text: 'Navigate to Contact',
                    color: 'primary',
                    callback: () => this.navigateToContact(submission)
                },
                {
                    icon: 'mdi-message',
                    text: 'Message contact',
                    color: 'primary',
                    callback: () => this.navigateToChannel(submission)
                }
            ]

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return our created action
            return action
        },
        submissionColumns(submission: FormSubmission): IListTileColumn[] {
            //  Grab our submission person
            const person = submission.person

            //  Grab our submission time
            const time = submission.submission_time

            //  Create our first column
            const one: IListTileColumn = {
                line1: this.$options.filters.personFullNameOrEmail(person),
                line2: this.$options.filters.personDefaultPhone(person)
            }

            //  Create our second column
            const two: IListTileColumn = {
                line1: 'Submission Time',
                line2: this.$options.filters.dateTime(time)
            }

            //  Create our columns container
            const columns: IListTileColumn[] = [one, two]

            //  Return our columns
            return columns
        },
        async submissionDelete(submission: FormSubmission) {
            //  Create our payload from our submission
            const payload = {
                ids: [submission.id],
                form_id: submission.form_id
            }

            //  Send and await our request
            const resp = await this.$store.dispatch('formSubmissionsDelete', payload)

            //  If request failed, do nothing
            if (!resp) return

            //  Else, pop a dialog informing the user about success
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Success',
                text: `Submission has been deleted.`,
                icon: 'mdi-check',
                color: 'primary'
            })
        },
        submissionTile(): IListTile {
            return {
                actionContent: (s: FormSubmission) => this.submissionActions(s),
                columns: (s: FormSubmission) => this.submissionColumns(s),
                leftIcon: this.submissionIcon,
                leftFooter: 'Contact',
                callback: (s: FormSubmission) => this.submissionView(s)
            }
        },
        submissionView(submission: FormSubmission): void {
            //  Pop an app form with the custom fields inputs
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Form Submission',
                icon: 'mdi-clipboard-text-search-outline',
                component: 'form-submission',
                overflow: 'auto',
                color: 'primary',
                closeOnSubmit: true,
                props: { submission: submission },
                callback: (type: string): void => {
                    //  Based on the type passed in, route to a different function
                    const cb = {
                        channel: () => this.navigateToChannel(submission),
                        contact: () => this.navigateToContact(submission),
                        delete: () => this.submissionDelete(submission)
                    }

                    //  Route
                    cb[type]()
                }
            })
        }
    }
})
